

















































































import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
import Label from '@/components/common/elements/Label.vue';
import Input from '@/components/common/elements/Input.vue';

@Component({
  components: { Label, Input }
})
export default class InputCalculation extends Vue {
  // ラベルのname属性
  @Prop({ default: '' })
  private leftSideLabelName!: string;
  @Prop({ default: '' })
  private rightSideLabelName!: string;
  @Prop({ default: '' })
  private calculateLabelName!: string;
  // ラベル内テキスト
  @Prop({ default: '' })
  private leftSideLabelText!: string;
  @Prop({ default: '' })
  private rightSideLabelText!: string;
  @Prop({ default: '' })
  private calculateLabelText!: string;
  // 追加付与クラス
  @Prop({ default: '' })
  private labelClass?: string;
  // 要素タイプ
  @Prop({ default: 'number' })
  private inputType?: string;
  // 入力要素名
  @Prop({ default: '' })
  private name!: string;
  // 入力要素名
  @Prop({ default: '' })
  private rightSideName!: string;
  // 左側入力要素初期値
  @Prop({ default: '' })
  private value?: string;
  // 右側入力要素初期値
  @Prop({ default: 0 })
  private rightSideInputValue?: number;
  // 入力要素プレースホルダ
  @Prop({ default: '' })
  private placeholder?: string;
  // 入力要素最大入力数
  @Prop({ default: '' })
  private maxlength?: string;
  // 入力要素がアクティブか否か
  @Prop({ default: false })
  private isDisabled?: boolean;
  // アイコンの付与
  @Prop({ default: '' })
  private appendIcon?: string;

  /** 左数値項目を3桁カンマ区切りで表現する設定 */
  @Prop({ default: false })
  private isLeftCommaNumber?: boolean;
  /** 右数値項目を3桁カンマ区切りで表現する設定 */
  @Prop({ default: false })
  private isRightCommaNumber?: boolean;
  /** 計算結果項目を3桁カンマ区切りで表現する設定 */
  @Prop({ default: false })
  private isCalculateCommaNumber?: boolean;

  private calculateValue = 0;
  private leftValue = 0;
  private rightValue = 0;

  /**
   * 入力箇所から左辺・右辺の値を更新・成型し、
   * 親コンポーネントに子コンポーネントの値を通知する
   * @module inputOperation
   * @param {[k: string]: string} data- input要素名と値
   * @return {[k: string]: string} data - input要素名と値
   */
  @Emit('inputOperation')
  public inputOperation(data: { name: string; value: string; type?: string }) {
    const str = data.name.slice(0, data.name.lastIndexOf('['));
    if (str === this.name.split(';')[0]) {
      this.leftValue = Number(data.value);
    } else if (str === this.name.split(';')[1]) {
      this.rightValue = Number(data.value);
    }
    data.type = this.inputType;
    this.computedValue = this.leftValue * this.rightValue;
    return data;
  }

  @Watch('value')
  onChangeValue() {
    this.applyPropValueUpdateToForm();
  }

  /**
   * 初期値の反映
   */
  created() {
    this.applyPropValueUpdateToForm();
  }

  /**
   * propertyのvalueの値を各フォームに反映させる
   */
  private applyPropValueUpdateToForm() {
    if (this.value) {
      this.leftValue = Number(this.value.split(';')[0]);
      this.rightValue = Number(this.value.split(';')[1]);
    }
    this.calculateValue = this.leftValue * this.rightValue;
  }

  /**
   * コンポーネント内でテキストフィールドへの値反映を完結するため、
   * 算出プロパティを設定する（直接propsを変更できないため）
   */  
  get computedValue() {
    return this.calculateValue;
  }
  set computedValue(newValue) {
    this.calculateValue = newValue;
  }
}
